import { JsonSerializable } from '../shared/jsonSerializable';
import { ThirdParty } from '../entity/third-party';

export class User extends JsonSerializable {

  username: string;
  name: string;
  password: string;
  plainPassword: string;
  mail: string;
  thirdParty: ThirdParty;

  constructor() {
    super();
    this.username = null;
    this.name = null;
    this.password = null;
    this.plainPassword = null;
    this.mail = null;
    this.thirdParty = null;
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {
        if(jsonObj[propName] instanceof Object){
          if(propName == "thirdParty"){
            this[propName] = new ThirdParty();
            this[propName].fromJSON(jsonObj[propName]);
          } else {
            this[propName] = jsonObj[propName];
          }
        } else {
          this[propName] = jsonObj[propName];
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/entity/user.ts